export function isEmptyObject(o: any) {
    return Object.keys(o).length === 0 && o.constructor === Object;
}
